import { GridColDef } from "@mui/x-data-grid";
import { t } from "i18next";
import DataGridApi from "../../../../components/dataGridApi";
import { ISpreadsheet } from "../../../../interfaces/ISpreadsheet";
import { CONFIG } from "../../../../services/config";

interface Props {
  spreadsheet?: ISpreadsheet;
}

export default function RevisaoExcecao({ spreadsheet }: Props) {
  const columns: GridColDef[] = [
    {
      field: "vin",
      flex: 1,
      headerName: t("digitalServicePlan.vin"),
      headerClassName: "header-style",
    },
    {
      field: "revisions",
      flex: 1,
      headerName: t("digitalServicePlan.freeRevisions"),
      headerClassName: "header-style",
    },
  ];
  return (
    <DataGridApi
      params1="&param="
      labelParams1="Chassi"
      host={CONFIG.SOB_API}
      endPoint={`excel/revisions/${spreadsheet?.id}?`}
      columnsData={columns}
    />
  );
}
